import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const outOfServiceReasonTypesAdapter = getAdapter({ idFieldName: 'value' });

const outOfServiceReasonTypesSlice = createSlice({
  name: 'outOfServiceReasonTypes',
  initialState: outOfServiceReasonTypesAdapter.getInitialState(),
  reducers: {
    setOOSReasonTypes: (state, { payload }) => outOfServiceReasonTypesAdapter.setAll(state, payload),
  },
});

const selectors = outOfServiceReasonTypesAdapter.getSelectors(({ outOfServiceReasonTypes }) => outOfServiceReasonTypes);

export const getOutOfServiceReasonTypesIncludingDeleted = (state) => selectors.selectAll(state);

export const getOutOfServiceReasonTypes = (state) =>
  getOutOfServiceReasonTypesIncludingDeleted(state).filter(({ deleted }) => !deleted);

export const { setOOSReasonTypes } = outOfServiceReasonTypesSlice.actions;

export default outOfServiceReasonTypesSlice.reducer;
